import './header.css';

export default function Header({ page, setPage }) {
  return (
    <header className={`navbar ${page !== 'home' ? 'solid' : ''}`}>
      <div className="brand" onClick={() => setPage('home')}>
        <span className="logo">N</span>
        <span className="brandname">NOVA<em>Realty</em></span>
      </div>

      <nav className="links">
        <button
          className={`link ${page === 'home' ? 'active' : ''}`}
          onClick={() => setPage('home')}
        >
          Home
        </button>
        <button
          className={`link ${page === 'properties' ? 'active' : ''}`}
          onClick={() => setPage('properties')}
        >
          Properties
        </button>
      </nav>

      <button className="cta" onClick={() => setPage('properties')}>
        View Properties
      </button>
    </header>
  );
}